import React from 'react';

const Datenschutz = () => {
  return (
    <div className="container w-50 mt-5 mb-5" style={{ textAlign: 'justify' }}>
      <h2 className="mb-4">Datenschutzerklärung</h2>

        <div className="fw-bold fs-4 mt-6 mb-3">Allgemeine Vorbemerkungen</div>
        <p>Die oben genannte Organisationseinheit und das IT und Medien Centrum (ITMC) der Technischen
            Universit&auml;t Dortmund nehmen den Schutz von personenbezogenen Daten sehr ernst. Wir
            verarbeiten
            personenbezogene Daten, die beim Besuch unserer Webseiten erhoben werden, unter Beachtung
            der geltenden
            datenschutzrechtlichen Bestimmungen. Es gelten insbesondere das Datenschutzgesetz NRW (DSG
            NRW), die
            Datenschutzgrundverordnung (DSGVO) und das Telemediengesetz.</p>
        <p></p>
        <div className="fw-bold fs-4 mt-6 mb-3">Kontaktdaten des Datenschutzbeauftragten</div>
        <p>Der Datenschutzbeauftragte des Verantwortlichen ist erreichbar unter:<br />&nbsp;</p>
        <p>TU Dortmund</p>
        <p>Datenschutzbeauftragter</p>
        <p>August-Schmidt-Str. 4<br />44227 Dortmund<br />Telefon: 0231-755 2593</p>
        <p>E-Mail senden an ralf.offele@tu-dortmund.de.</p>
        <p>&nbsp;</p>
        <div className="fw-bold fs-4 mt-6 mb-3">I Umfang der Verarbeitung personenbezogener Daten</div>
        <p>Wir verarbeiten personenbezogene Daten unserer Nutzer grunds&auml;tzlich nur, soweit dies zur
            Bereitstellung einer funktionsf&auml;higen Website sowie unserer Inhalte und Leistungen
            erforderlich
            ist. Die Verarbeitung personenbezogener Daten unserer Nutzer erfolgt regelm&auml;&szlig;ig
            nur nach
            Einwilligung des Nutzers. Eine Ausnahme gilt in solchen F&auml;llen, in denen eine vorherige
            Einholung
            einer Einwilligung aus tats&auml;chlichen Gr&uuml;nden nicht m&ouml;glich ist und die
            Verarbeitung der
            Daten durch gesetzliche Vorschriften gestattet ist.</p>
        <p>&nbsp;</p>
        <div className="fw-bold fs-4 mt-6 mb-3">II Datenl&ouml;schung und Speicherdauer</div>
        <p>Die personenbezogenen Daten der betroffenen Person werden gel&ouml;scht oder gesperrt, sobald
            der Zweck
            der Speicherung entf&auml;llt. Eine Speicherung kann dar&uuml;ber hinaus erfolgen, wenn dies
            durch den
            europ&auml;ischen oder nationalen Gesetzgeber in unionsrechtlichen Verordnungen, Gesetzen
            oder sonstigen
            Vorschriften, denen der Verantwortliche unterliegt, vorgesehen wurde. Eine Sperrung oder L&ouml;schung
            der Daten erfolgt auch dann, wenn eine durch die genannten Normen vorgeschriebene
            Speicherfrist
            abl&auml;uft, es sei denn, dass eine Erforderlichkeit zur weiteren Speicherung der Daten f&uuml;r
            einen
            Vertragsabschluss oder eine Vertragserf&uuml;llung besteht.</p>
        <p>&nbsp;</p>
        <div className="fw-bold fs-4 mt-6 mb-3">III Bereitstellung der Website und Erstellung von Logfiles</div>
        <p><strong>1. Beschreibung und Umfang der Datenverarbeitung</strong></p>
        <p>Bei jedem Aufruf unserer Internetseite erfasst unser System automatisiert Daten und
            Informationen vom
            Computersystem des aufrufenden Rechners.</p>
        <p>Folgende Daten werden hierbei erhoben:</p>
        <ul>
            <li>Informationen &uuml;ber den Browsertyp und die verwendete Version</li>
            <li>Betriebssystem des Nutzers</li>
            <li>IP-Adresse des Nutzers</li>
            <li>Datum und Uhrzeit des Zugriffs</li>
        </ul>
        <p>Die Daten werden ebenfalls in den Logfiles unseres Systems gespeichert. Eine Speicherung
            dieser Daten
            zusammen mit anderen personenbezogenen Daten des Nutzers findet nicht statt.<br /></p>
        <p>Zusätzlich werden die auf der 5G Campusnetzplaner Webseite getätigten Nutzereingaben nach
            freiwilligem
            Download einer zusammenfassenden PDF und/oder des eingegebenen Gebietsvektors als CSV-Datei
            für
            statistische Zwecke gespeichert.
        <p>Folgende Nutzereingaben werden hierbei erhoben:</p>
        <ul>
            <li>Gebietsvektor (= Wegpunkte des gewählten Polygonzugs) und dadurch eingeschlossene
                Flächengröße
            </li>
            <li>Bandbreite</li>
            <li>Laufzeit</li>
            <li>Differenzierung zwischen der Siedlungs- und Verkehrsfläche (a1) sowie anderen Flächen
                (a2)
            </li>
        </ul>
        <p>
            Die gespeicherten Daten werden ausschließlich im Rahmen des Competence Center 5G.NRW
            ausgewertet und
            anonymisiert in Form einer Statistik für die Öffentlichkeit aufbereitet. Eine
            Veröffentlichung erfolgt
            zum Beispiel über die Projektwebseite (<a href="https://5g.nrw">https://5g.nrw</a>) oder im
            Rahmen
            wissenschaftlicher
            Veröffentlichungen.</p>
        </p>
        <p><strong>2. Zweck und Rechtsgrundlage f&uuml;r die Datenverarbeitung</strong></p>
        <p>Die vor&uuml;bergehende Speicherung der IP-Adresse durch das System ist notwendig, um eine
            Auslieferung
            der Website an den Rechner des Nutzers zu erm&ouml;glichen. Hierf&uuml;r muss die IP-Adresse
            des Nutzers
            f&uuml;r die Dauer der Sitzung gespeichert bleiben. (Erforderlichkeit zur Erf&uuml;llung der
            Aufgabe der
            Hochschule Art. 6 Abs. 1 lit. e DSGVO)</p>
        <p>Die Speicherung in Logfiles erfolgt, um die Funktionsf&auml;higkeit der Website
            sicherzustellen. Zudem
            dienen uns die Daten zur Optimierung der Website und zur Sicherstellung der Sicherheit
            unserer
            informationstechnischen Systeme. Eine Auswertung der Daten zu Marketingzwecken findet in
            diesem
            Zusammenhang nicht statt. &nbsp;(Erforderlichkeit zur Erf&uuml;llung der Aufgabe der
            Hochschule Art. 6
            Abs. 1 lit. e DSGVO)<br /><br /></p>
        <p><strong>3. Dauer der Speicherung</strong></p>
        <p>Die Verarbeitung findet w&auml;hrend der Nutzung bis zum Ende der jeweiligen Sitzung
            statt.</p>
        <p>Im Falle der Speicherung der Daten in Logfiles ist dies nach sp&auml;testens 24 Stunden der
            Fall.
            Danach sind die IP-Adressen der Nutzer anonymisiert, sodass eine Zuordnung des aufrufenden
            Clients nicht
            mehr m&ouml;glich ist.<br /></p>
        <p>Die ergänzende Speicherung der ausgewiesenen Nutzereingaben erfolgt bis zum Ende des
            Durchführungszeitraumes des Projekts Competence Center 5G.NRW am 31.05.2022. Darüber hinaus
            sind die
            Nutzereingaben in statistischen Auswertungen anonymisiert aufbereitet, sodass darüber hinaus
            auch eine
            Gebietszuordnung nicht mehr möglich ist.</p>
        <div className="fw-bold fs-4 mt-6 mb-3">IV Rechte der betroffenen Person</div>
        <p>Werden personenbezogene Daten von Ihnen verarbeitet, sind Sie betroffene Person i.S.d. DSGVO
            und es
            stehen Ihnen folgende Rechte gegen&uuml;ber dem Verantwortlichen zu:</p>
        <p>Wenn sie ihre Rechte in Anspruch nehmen wollen, wenden Sie sich bitte an den
            Datenschutzbeauftragten
            der TU Dortmund. <br /><br /><strong>1. Auskunft (Art 15 DSGVO)</strong></p>
        <p>Sie haben das Recht auf Auskunft &uuml;ber Sie betreffende personenbezogene Daten, die
            erhoben,
            verarbeitet oder ggf. an Dritte &uuml;bermittelt werden.<br /><br /></p>
        <p><strong>2. Widerspruch (Art. 21 DSGVO)</strong><br />Sie haben das Recht gegen die Verarbeitung
            Ihrer
            personenbezogenen Daten Widerspruch einzulegen, soweit die Verarbeitung auf der Grundlage von Art. 6 (1)
            e oder f DSGVO erfolgt.<br /><br /></p>
        <p><strong>3. L&ouml;schung (Art 17 DSGVO)</strong><br />Insbesondere nach Ablauf der gesetzlich
            vorgeschriebenen Aufbewahrungsfristen haben Sie ein Recht auf L&ouml;schung Ihrer Daten.<br /><br />
        </p>
        <p><strong>4. Einschr&auml;nkung der Verarbeitung (Art 18 DSGVO)</strong></p>
        <p>In besonderen F&auml;llen haben Sie das Recht auf Einschr&auml;nkung der Verarbeitung. Dies
            ist dann
            der Fall, wenn die Datenverarbeitung unrechtm&auml;&szlig;ig sein sollte, Sie die
            Richtigkeit der
            erhobenen Daten bestreiten oder ein Widerspruch gegen die Verarbeitung eingelegt haben.
            Ebenso
            k&ouml;nnen Sie eine Einschr&auml;nkung der Verarbeitung verlangen, wenn die Daten aufgrund
            der
            Zweckerreichung einer L&ouml;schpflicht unterliegen, Sie sie jedoch zur Geltendmachung von
            rechtlichen
            Anspr&uuml;chen ben&ouml;tigen. Eine Einschr&auml;nkung der Verarbeitung m&uuml;ssen Sie
            beantragen.<br /><br /></p>
        <p><strong>5. Berichtigung (Art 16 DSGVO)</strong><br />Sie haben das Recht auf Berichtigung
            unrichtiger
            personenbezogener Daten.<br /><br /></p>
        <p><strong>6. Recht auf Widerruf der datenschutzrechtlichen Einwilligungserkl&auml;rung (Art 7
            DSGVO)</strong></p>
        <p>Sie haben das Recht, Ihre datenschutzrechtliche Einwilligungserkl&auml;rung jederzeit zu
            widerrufen.
            Durch den Widerruf der Einwilligung wird die Rechtm&auml;&szlig;igkeit der aufgrund der
            Einwilligung bis
            zum Widerruf erfolgten Verarbeitung nicht ber&uuml;hrt.<br /><br /></p>
        <p><strong>7. Recht auf Beschwerde bei einer Aufsichtsbeh&ouml;rde</strong></p>
        <p>Sie k&ouml;nnen sich jederzeit mit allen Fragen zum Datenschutz und um sich zu beschweren an
            eine
            Datenschutzaufsichtsbeh&ouml;rde wenden. Zust&auml;ndig ist in unserem Fall die
            Landesbeauftragte
            f&uuml;r Datenschutz und Informationsfreiheit in Nordrhein-Westfalen.</p>
        <p>Bitte beachten Sie, dass diese Datenschutzerkl&auml;rung nicht f&uuml;r alle Teile des
            Internetauftritts der TU Dortmund gilt.</p>
        <p></p>
        <p><strong>Name und Anschrift des Verantwortlichen</strong></p>
        <p>Der Verantwortliche im Sinne der Daten&shy;schutz-Grundverordnung und anderer nationaler
            Datenschutzgesetze der Mitgliedsstaaten sowie sonstiger datenschutzrechtlicher Bestimmungen
            ist die:</p>
        <p>TU Dortmund</p>
        <p>Der Rektor</p>
        <p>Technische Universit&auml;t Dortmund<br />August-Schmidt-Stra&szlig;e 4</p>
        <p>44227 Dortmund&nbsp;</p>
        <div className="fw-bold fs-4 mt-6 mb-3">Name und Anschrift des Verantwortlichen</div>
        <p>Der Verantwortliche im Sinne der Datenschutz-Grundverordnung und anderer nationaler
            Datenschutzgesetze
            der Mitgliedsstaaten sowie sonstiger datenschutzrechtlicher Bestimmungen ist:</p>
        <p>TU Dortmund<br />Fakult&auml;t f&uuml;r Elektrotechnik und Informationstechnik</p>
        <p>Der Dekan</p>
        <p>Technische Universit&auml;t Dortmund<br />Otto-Hahn-Stra&szlig;e 4, 44227 Dortmund<br />Telefon:
            0231/755-2123</p>
        <p></p>
    </div>
  );
};

export default Datenschutz;